import * as React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter, Switch } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';

import { ScrollToTop, PrivateRoute, PageNotFound } from '../youwell-common/components';
import urls from './urls';

import Outside from '../features/outside/Index';
import Inside from '../features/inside/Index';
import LoadProgramDetails from '../features/inside/components/LoadProgramDetails';
import Preview from '../features/preview/Index';
import StudentPortal from '../features/studentPortal/Index';
import Public from '../features/public/Index';

class App extends React.Component {
    render() {
        const {
            appConfig,
        } = this.props;

        return (
            <>
                <CssBaseline />
                <ScrollToTop />

                <Switch>
                    <Route path={urls.preview.home} />
                    <LoadProgramDetails programId={appConfig?.contentProgramId} content />
                </Switch>

                <Switch>
                    <Route exact path={urls.home} component={Outside} />
                    <Route path={urls.register} component={Outside} />
                    <Route path={urls.logout} component={Outside} />
                    <Route path={urls.login} component={Outside} />
                    <Route path={urls.page} component={Outside} />
                    <Route path={urls.preview.home} component={Preview} />
                    <Route path={urls.studentCode.home} component={StudentPortal} />
                    <Route path={urls.public.home} component={Public} />

                    <PrivateRoute
                        path={`${urls.inside.home}/:key?/:id?`}
                        component={Inside}
                        loginUrl={urls.login}
                    />

                    <Route component={PageNotFound} />
                </Switch>
            </>
        );
    }
}

App.propTypes = {
    appConfig: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    clientConfig: state.auth.clientConfig,
    appConfig: state.pageSettings.appConfig,
});

export default hot(module)(withRouter(connect(mapStateToProps)(App)));
